import React, { ReactElement, useContext } from 'react'
import Img from '../Img/Img'
import './StepDetails.css'
import { ImageData } from '../../services/fetchNameUrls'
import { Bounce } from 'react-activity'
import 'react-activity/dist/library.css'
import { ProductContext } from '../../context/ProductContext'
import AttachList from '../AttachList/AttachList'
import { PartNumberContext } from '../../context/PartNumberContext'

interface StepDetailsProps {
  description: string
  images: ImageData[]
}

function StepDetails ({ description, images }: StepDetailsProps): ReactElement {
  const [loading, setLoading] = React.useState(true)
  const { product } = useContext(ProductContext)
  const { partNumber, renderPartNumber } = useContext(PartNumberContext)

  const disableGeneralLoad = (): void => {
    setLoading(false)
  }

  const hasValidPartNumber = partNumber?.partnumber !== undefined && partNumber?.partnumber !== '-'

  const hasAttachments = (
    (((partNumber?.harnesses) != null) && partNumber.harnesses.length > 0) ||
    (((partNumber?.assets) != null) && partNumber.assets.length > 0) ||
    (((partNumber?.manuals) != null) && partNumber.manuals.length > 0)
  )

  const enableAttachList = hasValidPartNumber && hasAttachments

  return (
    <div className='step-details'>
      {(product != null) &&
        <div className='name-div'>
          <h4 className='name'>{product?.name}</h4>
          {renderPartNumber()}
        </div>}
      {enableAttachList && (
        <AttachList
          manuals={partNumber?.manuals}
          assets={partNumber?.assets}
          harness={partNumber?.harnesses}
        />)}
      <h4 className='image-description'>Description : </h4>
      <div className='descrip-div'>
        {description === '' && <h3 className='no-descrip-message'>No description available.</h3>}
        {description !== '' && <p className='descrip-box'>{description}</p>}
      </div>
      <h3 className='image-header'>Images</h3>
      {images.length === 0 && <h3 className='no-images-message'>No images available.</h3>}
      {images.length > 0 && <Bounce
        color='#4285f4'
        size={30}
        style={{ display: loading ? 'flex' : 'none', padding: '5%', justifyContent: 'center' }}
                            />}
      {images.length > 0 && (
        <div className='img-container'>
          <Img imgNames={images} disableGeneralLoad={disableGeneralLoad} />
        </div>
      )}
    </div>

  )
}

export default StepDetails
